export enum PathnameEnum {
  LOGIN_PAGE = '/login',
  MAIN_PAGE = '/main',
  STANDARD_OUTPUT_PAGE = '/output/standard',
  ADULTS_ONLY_OUTPUT_PAGE = '/output/special/adults-only',
  ACTION_GENRE_OUTPUT_PAGE = '/output/special/action-genre',
  BODY_PART_OUTPUT_PAGE = '/output/special/body-part',
  FACIAL_EXPRESSION_OUTPUT_PAGE = '/output/special/facial-expression',
  ETC_OUTPUT_PAGE = '/output/special/etc',
  USED_IMAGE_LIST_PAGE = '/collections/used-image-list',
  IMAGE_UPLOADER_ADULTS_ONLY_IMAGE_LIST_PAGE = '/image-uploader/adults-only/image-list',
  IMAGE_UPLOADER_ADULTS_ONLY_IMAGE_UPLOAD_PAGE = '/image-uploader/adults-only/image-upload',
  IMAGE_UPLOADER_ADULTS_ONLY_IMAGE_EDIT_PAGE = '/image-uploader/adults-only/image-edit/:imageIdParam',
  // ImageListItem component 내 locationPathname.includes('/collections') 여부로 분기처리 적용되어있으므로 수정/추가시 주의
  COLLECTION_LIST_PAGE = '/collections',
  COLLECTION_IMAGE_LIST_PAGE = '/collections/:collectionId'
}
